import i18n from '@/lang/i18n'

export default {
    title: i18n.t('configuration.elementTitle.incidents'),
    id: 'laboratoryIncidents',
    sidebar: [
        {
            id: 'localIncidentTypes',
            label: i18n.tc('configuration.sections.incidentTypes', 2),
            icon: 'fal fa-list-ul',
            routeName: 'LocalIncidentTypes',
            hasChildren: false
        },
        {
            id: 'localIncidentOrigins',
            label: i18n.tc('configuration.sections.incidentOrigins', 2),
            icon: 'far fa-map-marker-exclamation',
            routeName: 'LocalIncidentOrigins',
            hasChildren: false
        },
        {
            id: 'localIncidentsSeverity',
            label: i18n.tc('configuration.sections.incidentSeverities', 2),
            icon: 'far fa-alarm-clock',
            routeName: 'LocalIncidentSeverity',
            hasChildren: false
        }
    ]
}
